export default __webpack_public_path__ + "static/media/NotFound.109ce83c.gif";